/* DEMARE PDP Bundle-Relaunch — Set-Konfigurator, Modellwahl, Sticky ATC
   Vanilla JS, keine Libraries. Liest Konfiguration aus data-Attributen. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pdp]');
  if (!root) return;

  var cfg = {
    mode: root.dataset.mode || 'set',
    threshold: parseInt(root.dataset.freeShip || '5000', 10),
    cordPrice: parseInt(root.dataset.cordPrice || '1590', 10),
    /* Set-Rabatt je Kordel in Cent (Festbetrag) — dieselbe Zahl wie an der Kasse (snippets/dm-set-off) */
    off: parseInt(root.dataset.setOff || '0', 10) || 0,
    caseVariant: root.dataset.caseVariant || '',
    variantPrice: parseInt(root.dataset.variantPrice || '0', 10),
    upsellPrice: parseInt(root.dataset.upsellPrice || '990', 10)
  };

  /* Modellname -> [Varianten-ID, verfuegbar, Preis]. Ohne die Map ging bisher
     IMMER die erste Variante in den Warenkorb, egal welches Modell gewaehlt war. */
  var VMAP = {};
  try { VMAP = JSON.parse(root.querySelector('[data-variant-map]').textContent); } catch (e) {}

  var state = { pkg: null, slots: [], target: 0, model: null, upCord: null };

  /* ---------- Bundle (15.10.) ----------
     "statt Einzelkauf" = Huelle (Preis fuer das gewaehlte Modell) + beide Kordeln,
     alles echte Einzelpreise. Ohne Modell: guenstigste Huellen-Variante. */
  var BCASE = {};
  try { BCASE = JSON.parse(root.querySelector('[data-bdl-case]').textContent); } catch (e) {}
  var bdl = {
    base: parseInt(root.dataset.bdlBase || '0', 10),
    caseMin: parseInt(root.dataset.bdlCaseMin || '0', 10),
    upOn: root.hasAttribute('data-bdl-up-on'),
    konf: root.querySelector('[data-bdl-konf]'),
    up: root.querySelector('[data-bdl-up]'),
    upAdd: root.querySelector('[data-bdl-up-add]'),
    upCords: root.querySelectorAll('[data-bdl-up-cord]')
  };
  var konfBase = bdl.konf ? bdl.konf.getAttribute('href') : '';
  function bundleUpdate(price, ok) {
    var key = state.model ? state.model.toLowerCase().replace(/\s+/g, '') : null;
    var cp = (key && typeof BCASE[key] === 'number') ? BCASE[key] : bdl.caseMin;
    var ref = cp + bdl.base;
    if (el.was) {
      var show = bdl.base > 0 && cp > 0 && ref > price;
      el.was.textContent = show ? 'statt Einzelkauf ' + eur(ref) : '';
      el.was.hidden = !show;
    }
    if (bdl.konf && konfBase) {
      bdl.konf.setAttribute('href', konfBase + (state.model ? '&model=' + encodeURIComponent(state.model) : ''));
    }
    if (bdl.upAdd) {
      var c = state.upCord;
      bdl.upAdd.disabled = !(ok && c);
      bdl.upAdd.textContent = !c ? 'Kordel antippen'
        : (!ok ? PICK : 'Mit 3. Kordel in den Warenkorb · ' + eur(price + c.now));
    }
    /* 15.10. abends: Versandversprechen nur, wenn Preis + guenstigste Upsell-Kordel die
       interne Grenze (49,80) erreicht -- sonst ehrlicher Rest-Betrag */
    var upH = root.querySelector('[data-bdl-up-h]');
    var upFree = upH ? parseInt(upH.dataset.free || '4980', 10) : 4980;
    var upMin = upH ? parseInt(upH.dataset.min || '0', 10) : 0;
    var upTail = root.querySelector('[data-bdl-up-tail]');
    if (upTail) {
      var rest = upFree - price - upMin;
      upTail.textContent = rest <= 0 ? ' → Versand gratis' : ' – danach noch ' + eur(rest) + ' bis zum Gratisversand';
    }
    if (el.hint && bdl.up && price < upFree && price + upMin >= upFree) {
      el.hint.textContent = 'Noch ' + eur(cfg.threshold - price) + ' bis zum Gratisversand – mit der 3. Kordel geschafft';
    }
  }
  function addBundle(withCord) {
    if (!state.model && el.mOpts.length) return;
    var items = [];
    if (withCord && state.upCord) {
      items.push({ id: parseInt(state.upCord.id, 10), quantity: 1,
        properties: { 'Teil von Set': '3. Kordel', '_upsell': 'bundle3' } });
    }
    /* Bundle zuletzt: Shopify zeigt die zuletzt geschickte Position oben */
    items.push({ id: parseInt(cfg.caseVariant, 10), quantity: 1 });
    var btns = [el.atc, el.stickyB, bdl.upAdd].filter(Boolean);
    btns.forEach(function (b) { b.disabled = true; });
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () {
        btns.forEach(function (b) { b.disabled = false; });
        if (el.atc) el.atc.textContent = 'Fehler — bitte erneut versuchen';
      });
  }
  Array.prototype.forEach.call(bdl.upCords, function (b) {
    b.addEventListener('click', function () {
      var on = b.getAttribute('aria-pressed') !== 'true';
      Array.prototype.forEach.call(bdl.upCords, function (x) { x.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', String(on));
      state.upCord = on ? { id: b.dataset.bdlUpCord, name: b.dataset.name, now: parseInt(b.dataset.now || '990', 10) } : null;
      update();
    });
  });
  if (bdl.upAdd) bdl.upAdd.addEventListener('click', function () { addBundle(true); });
  /* Beschriftung der Auswahl: nur bei Handymodellen "Modell", sonst der Optionsname (Größe, Farbe …) */
  var OPT = (root.dataset.optLabel || '').trim();
  var PICK = (OPT && !/modell/i.test(OPT) ? OPT : 'Modell') + ' wählen';

  var el = {
    pkgs:    root.querySelectorAll('[data-pkg]'),
    slots:   root.querySelector('[data-slots]'),
    swatches:root.querySelectorAll('[data-cord]'),
    atc:     root.querySelector('[data-atc]'),
    hint:    root.querySelector('[data-ship-hint]'),
    fill:    root.querySelector('[data-ship-fill]'),
    price:   root.querySelector('[data-price-now]'),
    was:     root.querySelector('[data-price-was]'),
    hero:    root.querySelector('[data-hero-img]'),
    sticky:  document.querySelector('[data-pdp-sticky]'),
    stickyP: document.querySelector('[data-pdp-sticky-price]'),
    stickyT: document.querySelector('[data-pdp-sticky-title]'),
    stickyB: document.querySelector('[data-pdp-sticky-add]'),
    mToggle: root.querySelector('[data-model-toggle]'),
    mPanel:  root.querySelector('[data-model-panel]'),
    mCurrent:root.querySelector('[data-model-current]'),
    mSearch: root.querySelector('[data-model-search]'),
    mOpts:   root.querySelectorAll('[data-model-value]'),
    mBrands: root.querySelectorAll('[data-brand]')
  };

  /* Kasse nachrechnen: bis zu 2 Kordeln um je cfg.off Cent verbilligt (Festbetrag
     "8,40 € Rabatt je Stueck" im BXGY-Rabatt, seit 23.09.). Nie unter 0. */
  function discounted(cents) { return Math.max(0, cents - cfg.off); }

  function eur(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ---------- Set-Pakete ---------- */
  function selectPkg(node) {
    state.pkg = {
      cords: parseInt(node.dataset.cords || '0', 10),
      price: parseInt(node.dataset.price || '0', 10),
      label: node.dataset.label || ''
    };
    Array.prototype.forEach.call(el.pkgs, function (p) {
      p.classList.toggle('is-active', p === node);
      var input = p.querySelector('input');
      if (input) input.checked = (p === node);
    });
    state.slots = new Array(state.pkg.cords).fill(null);
    state.target = 0;
    renderSlots();
    update();
  }

  /* ---------- Kordel-Slots ---------- */
  function renderSlots() {
    if (!el.slots) return;
    el.slots.innerHTML = '';
    if (!state.pkg || state.pkg.cords === 0) return;
    state.slots.forEach(function (slot, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pdp-slot' + (slot ? ' is-filled' : '') + (i === state.target && !slot ? ' is-target' : '');
      b.setAttribute('aria-label', slot ? 'Kordel ' + slot.name + ' entfernen' : 'Kordel ' + (i + 1) + ' wählen');
      if (slot) {
        b.innerHTML = '<img src="' + slot.img + '" alt="' + slot.name + '"><span class="pdp-slot__x">×</span>';
        b.onclick = function () { state.slots[i] = null; state.target = i; renderSlots(); update(); };
      } else {
        b.textContent = '+';
        b.onclick = function () { state.target = i; renderSlots(); };
      }
      el.slots.appendChild(b);
    });
  }

  function pickCord(btn) {
    if (btn.disabled) return;
    /* 13.10.: "Nur Hülle" ist vorgewählt. Tippt man trotzdem eine Kordel an,
       wechselt die Auswahl ins Set (vorher passierte nichts). */
    if (state.pkg && state.pkg.cords === 0) {
      var setPkg = root.querySelector('[data-pkg][data-cords="2"]');
      if (setPkg) selectPkg(setPkg);
    }
    if (!state.pkg || state.pkg.cords === 0) return;
    var cord = {
      id: btn.dataset.cordVariant,
      name: btn.dataset.cordName || '',
      img: btn.dataset.cordImage || '',
      price: parseInt(btn.dataset.cordPrice || '0', 10)
    };
    var idx = state.slots.indexOf(null);
    if (state.slots[state.target] === null) idx = state.target;
    if (idx === -1) idx = state.slots.length - 1;
    state.slots[idx] = cord;
    var next = state.slots.indexOf(null);
    state.target = next === -1 ? idx : next;
    if (el.hero && cord.img && idx === 0) el.hero.src = cord.img;
    renderSlots();
    update();
  }

  /* ---------- Preis, CTA, Versand-Fortschritt ---------- */
  function update() {
    /* combo/simple: normaler Einzelkauf — Preis der Variante, kein Paket */
    if (cfg.mode !== 'set') {
      var p2 = cfg.variantPrice;
      var needModel = el.mOpts.length > 0;
      var ok = !needModel || !!state.model;
      if (el.price && p2) el.price.textContent = eur(p2);
      if (el.was && cfg.mode !== 'bundle') el.was.hidden = true;
      if (el.atc) {
        el.atc.disabled = !ok;
        el.atc.textContent = ok ? 'In den Warenkorb · ' + eur(p2) : PICK;
      }
      var rest2 = cfg.threshold - p2;
      if (el.fill) el.fill.style.width = Math.min(100, p2 / cfg.threshold * 100) + '%';
      if (el.hint) el.hint.textContent = rest2 > 0
        ? 'Noch ' + eur(rest2) + ' bis zum Gratisversand' : 'Gratisversand erreicht';
      if (el.stickyP) el.stickyP.textContent = eur(p2);
      if (el.stickyB) el.stickyB.disabled = !ok;
      if (cfg.mode === 'bundle') bundleUpdate(p2, ok);
      return;
    }
    if (!state.pkg) return;
    /* "Nur Huelle" kostet, was die gewaehlte Variante kostet — keine Pauschale. */
    var casePrice = cfg.variantPrice || parseInt(root.dataset.casePrice || '0', 10);
    /* Genau der Betrag, den die Kasse verlangt — kein fester Paketpreis mehr
       (21.09.: bei Neon stand 44,90 da, die Kasse haette 46,90 verlangt). */
    var price = casePrice;
    for (var i = 0; i < state.pkg.cords; i++) {
      var sl = state.slots[i];
      price += discounted(sl && sl.price ? sl.price : cfg.cordPrice);
    }
    var filled = state.slots.filter(Boolean).length;
    var missing = state.pkg.cords - filled;

    /* Solange Plaetze leer sind und die Kordeln unterschiedlich kosten, ist das ein ab-Preis */
    var ab = missing > 0 && state.pkg.cords > 0 && root.hasAttribute('data-cord-varies');
    if (el.price) el.price.textContent = (ab ? 'ab ' : '') + eur(price);
    if (el.was) {
      /* Einzelkauf = echte Huelle + echte gewaehlte Kordeln + fuer leere Plaetze
         die guenstigste passende Kordel. Nie hoeher als die Wirklichkeit. */
      var ref = casePrice +
        state.slots.filter(Boolean).reduce(function (a, c) { return a + (c.price || cfg.cordPrice); }, 0) +
        missing * cfg.cordPrice;
      var showWas = state.pkg.cords > 0 && ref > price;
      el.was.textContent = showWas ? 'statt Einzelkauf ' + eur(ref) : '';
      el.was.hidden = !showWas;
    }

    var ready = missing <= 0 && !!state.model;
    if (el.atc) {
      el.atc.disabled = !ready;
      el.atc.textContent = missing > 0
        ? 'Noch ' + missing + ' Kordel' + (missing > 1 ? 'n' : '') + ' wählen'
        : (!state.model ? PICK : 'In den Warenkorb · ' + eur(price));
    }

    var rest = cfg.threshold - price;
    if (el.fill) el.fill.style.width = Math.min(100, price / cfg.threshold * 100) + '%';
    if (el.hint) {
      /* Kein "3. Kordel fuer 9,90"-Claim mehr: dieses Angebot existiert
         (noch) nicht als Rabatt -> nicht einloesbares Versprechen. */
      el.hint.textContent = rest > 0
        ? 'Noch ' + eur(rest) + ' bis zum Gratisversand'
        : 'Gratisversand erreicht';
    }

    if (el.stickyP) el.stickyP.textContent = eur(price);
    if (el.stickyT) el.stickyT.textContent = state.pkg.label + (state.model ? ' · ' + state.model : '');
    if (el.stickyB) el.stickyB.disabled = !ready;
  }

  /* ---------- Modellwahl ---------- */
  var LS = 'demare:lastModel';

  function setModel(value, persist) {
    var vm = VMAP[value];
    if (vm && !vm[1]) return;                      /* ausverkaufte Modelle nicht waehlbar */
    state.model = value;
    if (vm) {
      cfg.caseVariant = String(vm[0]); cfg.variantPrice = vm[2];
      var sp = document.querySelector('[data-solo-price]');
      if (sp && vm[2]) sp.textContent = eur(vm[2]);
      var s2 = document.querySelector('[data-set2-price]');
      if (s2 && vm[2]) s2.textContent = (root.hasAttribute('data-cord-varies') ? 'ab ' : '') +
        eur(vm[2] + 2 * discounted(cfg.cordPrice));
      /* Express-Checkout kauft die Variante direkt — Feld mitziehen,
         sonst kauft PayPal das zuerst gerenderte Modell. */
      var ev = document.querySelector('[data-express-variant]');
      if (ev) ev.value = vm[0];
      /* Express-Checkout erst jetzt freigeben (QA P08-4) */
      var ef = document.getElementById('pdp-express-form');
      if (ef) ef.classList.remove('is-locked');
      /* Streichpreis folgt der Variante: je Modell kann ein anderer
         compare_at_price hinterlegt sein. */
      var cp = document.querySelector('[data-price-compare]');
      if (cp) {
        if (vm[3] && vm[3] > vm[2]) { cp.textContent = eur(vm[3]); cp.hidden = false; }
        else { cp.hidden = true; }
      }
    }
    if (el.mCurrent) el.mCurrent.textContent = value;
    Array.prototype.forEach.call(el.mOpts, function (o) {
      o.setAttribute('aria-selected', String(o.dataset.modelValue === value));
    });
    if (persist) { try { localStorage.setItem(LS, value); } catch (e) {} }
    update();
  }

  /* Ausverkaufte Modelle in der Liste sperren */
  Array.prototype.forEach.call(el.mOpts, function (o) {
    var vm = VMAP[o.dataset.modelValue];
    if (vm && !vm[1]) { o.disabled = true; o.textContent += ' — ausverkauft'; }
  });

  function filterModels() {
    var q = (el.mSearch && el.mSearch.value || '').toLowerCase().trim();
    var brand = null;
    Array.prototype.forEach.call(el.mBrands, function (b) {
      if (b.getAttribute('aria-pressed') === 'true') brand = b.dataset.brand.toLowerCase();
    });
    Array.prototype.forEach.call(el.mOpts, function (o) {
      var v = o.dataset.modelValue.toLowerCase();
      var okQ = !q || v.indexOf(q) > -1;
      var okB = !brand || v.indexOf(brand) > -1
             || (brand === 'apple' && v.indexOf('iphone') > -1)
             || (brand === 'google' && v.indexOf('pixel') > -1);
      o.hidden = !(okQ && okB);
    });
  }

  /* ---------- Cart ---------- */
  function addToCart() {
    if (cfg.mode === 'bundle') { addBundle(false); return; }
    if (cfg.mode !== 'set') {
      var needModel2 = el.mOpts.length > 0;
      if (needModel2 && !state.model) return;
      var btns2 = [el.atc, el.stickyB].filter(Boolean);
      btns2.forEach(function (b) { b.disabled = true; });
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(cfg.caseVariant, 10), quantity: 1 }] })
      }).then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          btns2.forEach(function (b) { b.disabled = false; });
          if (el.atc) el.atc.textContent = 'Fehler — bitte erneut versuchen';
        });
      return;
    }
    if (!state.pkg) return;
    /* Shopify rendert die ZULETZT geschickte Position ganz oben — deshalb
       Kordeln zuerst, Huelle zuletzt, damit die Huelle als Set-Kopf steht.
       _set_id gruppiert die Positionen (Unterstrich = unsichtbar im Checkout). */
    var caseItem = { id: cfg.caseVariant, quantity: 1 };
    var items = [];
    if (state.pkg.cords > 0) {
      var sid = 'set-' + Date.now().toString(36);
      caseItem.properties = { 'Set': state.pkg.label, '_set_id': sid, '_set_role': 'case' };
      state.slots.filter(Boolean).forEach(function (c) {
        items.push({ id: c.id, quantity: 1,
          properties: { 'Teil von Set': state.pkg.label, '_set_id': sid, '_set_role': 'part' } });
      });
    }
    items.push(caseItem);
    var btns = [el.atc, el.stickyB].filter(Boolean);
    btns.forEach(function (b) { b.disabled = true; });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () {
        btns.forEach(function (b) { b.disabled = false; });
        if (el.atc) el.atc.textContent = 'Fehler — bitte erneut versuchen';
      });
  }

  /* ---------- Init ---------- */
  Array.prototype.forEach.call(el.pkgs, function (p) {
    p.addEventListener('click', function () { selectPkg(p); });
  });
  Array.prototype.forEach.call(el.swatches, function (s) {
    s.addEventListener('click', function () { pickCord(s); });
  });
  if (el.atc) el.atc.addEventListener('click', addToCart);
  if (el.stickyB) el.stickyB.addEventListener('click', addToCart);

  if (el.mToggle && el.mPanel) {
    el.mToggle.addEventListener('click', function () {
      el.mPanel.hidden = !el.mPanel.hidden;
      if (!el.mPanel.hidden && el.mSearch) el.mSearch.focus();
    });
  }
  if (el.mSearch) el.mSearch.addEventListener('input', filterModels);
  Array.prototype.forEach.call(el.mBrands, function (b) {
    b.addEventListener('click', function () {
      var on = b.getAttribute('aria-pressed') === 'true';
      Array.prototype.forEach.call(el.mBrands, function (x) { x.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', String(!on));
      filterModels();
    });
  });
  Array.prototype.forEach.call(el.mOpts, function (o) {
    o.addEventListener('click', function () {
      setModel(o.dataset.modelValue, true);
      if (el.mPanel) el.mPanel.hidden = true;
    });
  });

  /* ---------- Galerie ----------
     18.09. (Julian): Bilder luden sehr langsam und Wischen fehlte in der
     Hauptgalerie. Ursache der Langsamkeit waren feste 1800px-Dateien, die
     erst beim Oeffnen angefordert wurden. */
  var zoomIdx = 0;
  var thumbBtns = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));

  /* CDN-Breite ans Geraet anpassen — ein 375px-Handy braucht keine 1800px. */
  function sized(url) {
    if (!url) return url;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var want = Math.round(Math.min(window.innerWidth, window.innerHeight) * dpr);
    var steps = [450, 600, 900, 1200, 1500, 1800];
    var pick = steps[steps.length - 1];
    for (var i = 0; i < steps.length; i++) { if (steps[i] >= want) { pick = steps[i]; break; } }
    return url.replace(/([?&]width=)\d+/, '$1' + pick);
  }

  var preloaded = {};
  function preload(url) {
    if (!url || preloaded[url]) return;
    var im = new Image();
    im.decoding = 'async';
    im.onload = function () { preloaded[url] = true; };
    im.src = url;
  }

  function setHero(i) {
    if (!thumbBtns.length) return;
    zoomIdx = (i + thumbBtns.length) % thumbBtns.length;
    var t = thumbBtns[zoomIdx];
    if (el.hero) { el.hero.src = t.dataset.thumb; el.hero.removeAttribute('srcset'); }
    thumbBtns.forEach(function (x) { x.setAttribute('aria-current', String(x === t)); });
    /* Nachbarn im Hintergrund holen, damit Wischen sofort reagiert. */
    var nxt = thumbBtns[(zoomIdx + 1) % thumbBtns.length];
    var prv = thumbBtns[(zoomIdx - 1 + thumbBtns.length) % thumbBtns.length];
    if (nxt) preload(nxt.dataset.thumb);
    if (prv) preload(prv.dataset.thumb);
  }

  thumbBtns.forEach(function (t, i) {
    t.addEventListener('click', function () { setHero(i); });
  });

  /* Wischen direkt in der Hauptgalerie (Wunsch Julian 18.09.).
     Ein Wisch darf die Lightbox nicht mit oeffnen — daher der Marker. */
  var gal = root.querySelector('.pdp-gal__main');
  if (gal && thumbBtns.length > 1) {
    var gx = null, gy = null, swiped = false;
    gal.addEventListener('touchstart', function (e) {
      gx = e.touches[0].clientX; gy = e.touches[0].clientY; swiped = false;
    }, { passive: true });
    gal.addEventListener('touchmove', function (e) {
      if (gx === null) return;
      var dx = e.touches[0].clientX - gx;
      var dy = e.touches[0].clientY - gy;
      /* Nur horizontale Gesten abfangen, vertikales Scrollen bleibt frei. */
      if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) swiped = true;
    }, { passive: true });
    gal.addEventListener('touchend', function (e) {
      if (gx === null) return;
      var dx = e.changedTouches[0].clientX - gx;
      var dy = e.changedTouches[0].clientY - gy;
      gx = null; gy = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        setHero(zoomIdx + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });
    gal.addEventListener('click', function (e) {
      if (swiped) { e.stopImmediatePropagation(); e.preventDefault(); swiped = false; }
    }, true);
  }

  /* Erste Nachbarn vorladen -- Speed 15.10.: erst nach window.load, damit sie nicht
     mit dem LCP-Bild um die Bandbreite konkurrieren */
  if (thumbBtns.length > 1) {
    var preloadNeighbours = function () {
      preload(thumbBtns[1].dataset.thumb);
      preload(thumbBtns[thumbBtns.length - 1].dataset.thumb);
    };
    if (document.readyState === 'complete') preloadNeighbours();
    else window.addEventListener('load', preloadNeighbours, { once: true });
  }

  /* Lightbox (Julian 13.09.: "Bilder lassen sich nicht anklicken") */
  var zoom = root.querySelector('[data-zoom]');
  var zOpen = root.querySelector('[data-zoom-open]');
  if (zoom && zOpen) {
    var zImg = zoom.querySelector('[data-zoom-img]');
    var zCount = zoom.querySelector('[data-zoom-count]');
    var srcs = Array.prototype.map.call(root.querySelectorAll('[data-thumb]'), function (t) { return t.dataset.zoom; });
    if (!srcs.length && el.hero) srcs = [el.hero.dataset.zoomSrc || el.hero.src];
    var lastFocus = null;
    function show(i) {
      zoomIdx = (i + srcs.length) % srcs.length;
      var mine = zoomIdx;
      var full = sized(srcs[zoomIdx]);
      if (zCount) zCount.textContent = srcs.length > 1 ? (zoomIdx + 1) + ' / ' + srcs.length : '';

      if (preloaded[full]) { zImg.src = full; }
      else {
        /* Sofort das kleine, laengst geladene Bild zeigen — dann scharf
           nachziehen. Vorher stand hier sekundenlang eine weisse Flaeche. */
        var small = thumbBtns[zoomIdx] && thumbBtns[zoomIdx].dataset.thumb;
        if (small) zImg.src = small;
        var hi = new Image();
        hi.decoding = 'async';
        hi.onload = function () {
          preloaded[full] = true;
          if (zoomIdx === mine && !zoom.hidden) zImg.src = full;
        };
        hi.src = full;
      }
      /* Nachbarbilder in der Zielgroesse vorbereiten */
      preload(sized(srcs[(zoomIdx + 1) % srcs.length]));
      preload(sized(srcs[(zoomIdx - 1 + srcs.length) % srcs.length]));
    }
    function openZoom() {
      lastFocus = document.activeElement;
      show(zoomIdx); zoom.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      zoom.querySelector('[data-zoom-close]').focus();
    }
    function closeZoom() {
      zoom.hidden = true; document.documentElement.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    zOpen.addEventListener('click', openZoom);
    zOpen.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openZoom(); } });
    zoom.querySelector('[data-zoom-close]').addEventListener('click', closeZoom);
    zoom.querySelector('[data-zoom-prev]').addEventListener('click', function () { show(zoomIdx - 1); });
    zoom.querySelector('[data-zoom-next]').addEventListener('click', function () { show(zoomIdx + 1); });
    zoom.addEventListener('click', function (e) { if (e.target === zoom) closeZoom(); });
    document.addEventListener('keydown', function (e) {
      if (zoom.hidden) return;
      if (e.key === 'Escape') closeZoom();
      if (e.key === 'ArrowLeft') show(zoomIdx - 1);
      if (e.key === 'ArrowRight') show(zoomIdx + 1);
    });
    /* Wischen auf dem Handy */
    var tx = null;
    zoom.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    zoom.addEventListener('touchend', function (e) {
      if (tx === null) return;
      var dx = e.changedTouches[0].clientX - tx; tx = null;
      if (Math.abs(dx) > 40) show(zoomIdx + (dx < 0 ? 1 : -1));
    });
    if (srcs.length < 2) {
      zoom.querySelector('[data-zoom-prev]').hidden = true;
      zoom.querySelector('[data-zoom-next]').hidden = true;
    }
  }

  /* Sticky ATC — Scroll-basiert statt IntersectionObserver.
     IO-Callbacks werden in versteckten/gedrosselten Dokumenten nicht
     zugestellt; die Leiste blieb dann dauerhaft aus. */
  if (el.sticky && el.atc) {
    var ticking = false;

    function syncSticky() {
      ticking = false;
      var r = el.atc.getBoundingClientRect();
      var visible = r.bottom > 0 && r.top < (window.innerHeight - 80);
      el.sticky.hidden = visible;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(syncSticky);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    syncSticky();
  }

  /* Startzustand: vorausgewähltes Paket + gemerktes Modell */
  var pre = root.querySelector('[data-pkg][data-preselected="true"]') || el.pkgs[0];
  if (cfg.mode === 'set' && pre) selectPkg(pre);
  if (cfg.mode !== 'set') update();

  /* 29.09.: Die Variante aus der Adresse (?variant=…, so verlinken Shopping-Anzeigen) gewinnt
     vor dem gemerkten Modell. Vorher: Klick auf die Anzeige "iPhone 17" landete ohne Vorauswahl
     ("Modell wählen"), und ein frueher gemerktes "iPhone 13" war sogar vorausgewaehlt und
     kaufbar — falsches Modell im Warenkorb. */
  var fromUrl = null;
  try {
    var uv = new URLSearchParams(window.location.search).get('variant');
    if (uv) {
      for (var mk in VMAP) {
        if (Object.prototype.hasOwnProperty.call(VMAP, mk) && String(VMAP[mk][0]) === String(uv) && VMAP[mk][1]) { fromUrl = mk; break; }
      }
    }
  } catch (e) {}
  var saved = null;
  try { saved = localStorage.getItem(LS); } catch (e) {}
  var match = null;
  if (fromUrl) Array.prototype.forEach.call(el.mOpts, function (o) {
    if (!match && o.dataset.modelValue === fromUrl) match = o;
  });
  var viaUrl = !!match;
  if (!match) Array.prototype.forEach.call(el.mOpts, function (o) {
    if (!match && saved && o.dataset.modelValue === saved) match = o;
  });
  if (match) setModel(match.dataset.modelValue, viaUrl);
  else if (el.mCurrent) el.mCurrent.textContent = el.mCurrent.dataset.placeholder || PICK;
  update();
})();
